<div *ngIf="depositDir" class="side-bar" [ngClass]="{'side-bar-open': panelOpened}" (click)="togglePanel()">
  <div class="side-bar-handle">
    <i *ngIf="!panelOpened" class="fa fa-bars"></i>
    <i *ngIf="panelOpened" class="fa fa-arrow-circle-left"></i>
  </div>
  <div class="col-12">
    <div class="center">
      <div class="col-12" *ngIf="savingTrial && savingTrial > 1">
        <p>{{'UPLOAD_COMPONENT.SAVE_DEPOSIT_TRIAL' | translate}}: {{savingTrial}}</p>
      </div>
      <div class="col-12" *ngIf="progressPersisted">
        <p-progressBar [value]="progressPersisted"></p-progressBar>
      </div>
      <div class="col-12" *ngIf="depositPersistedSerialLot">
        <p *ngIf="depositPersistedSerialLot">{{'UPLOAD_COMPONENT.STATUS_SERIAL_DEPOSIT' | translate}}: {{depositPersistedSerialLot}}</p>
      </div>
    </div>
  </div>
</div>
